/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Transcript_DescInputs */

const en_file_export_transcript_desc = /** @type {(inputs: File_Export_Transcript_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plain text TXT, DOCX, CSV`)
};

const fr_file_export_transcript_desc = /** @type {(inputs: File_Export_Transcript_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texte brut TXT, DOCX, CSV`)
};

const de_file_export_transcript_desc = /** @type {(inputs: File_Export_Transcript_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klartext (TXT, DOCX, CSV)`)
};

const it_file_export_transcript_desc = /** @type {(inputs: File_Export_Transcript_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testo normale TXT, DOCX, CSV`)
};

const ru_file_export_transcript_desc = /** @type {(inputs: File_Export_Transcript_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обычный текст TXT, DOCX, CSV`)
};

const es_file_export_transcript_desc = /** @type {(inputs: File_Export_Transcript_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto sin formato TXT, DOCX, CSV`)
};

const zh_cn2_file_export_transcript_desc = /** @type {(inputs: File_Export_Transcript_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`纯文本 TXT、DOCX、CSV`)
};

const ja_file_export_transcript_desc = /** @type {(inputs: File_Export_Transcript_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレーンテキスト TXT、DOCX、CSV`)
};

const hi_file_export_transcript_desc = /** @type {(inputs: File_Export_Transcript_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`साधारण टेक्स्ट TXT, DOCX, CSV`)
};

const pt_pt2_file_export_transcript_desc = /** @type {(inputs: File_Export_Transcript_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto simples TXT, DOCX, CSV`)
};

/**
* | output |
* | --- |
* | "Plain text TXT, DOCX, CSV" |
*
* @param {File_Export_Transcript_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_transcript_desc = /** @type {((inputs?: File_Export_Transcript_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Transcript_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_transcript_desc(inputs)
	if (locale === "de") return de_file_export_transcript_desc(inputs)
	if (locale === "it") return it_file_export_transcript_desc(inputs)
	if (locale === "ru") return ru_file_export_transcript_desc(inputs)
	if (locale === "es") return es_file_export_transcript_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_transcript_desc(inputs)
	if (locale === "ja") return ja_file_export_transcript_desc(inputs)
	if (locale === "hi") return hi_file_export_transcript_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_transcript_desc(inputs)
	return en_file_export_transcript_desc(inputs)
});